<template>
    <tq-dropdown class="TQ_direction_rtl"
                 :p_show_vb="showDropDown_bv"
                 :show-caret-down="false"
                 :only-laptop-mode="true"
                 options-width="210px"
                 max-height="350px"
                 :p_overflow-visible_b="true">


        <div class="lc_navIcon" slot="select" :class="helper_getScreenSizeCssClass_s(windowSizeType_ve.val)">
            <div :class="{'lc_navIconOpen1' : showDropDown_bv.val}" ></div>
            <div :class="{'lc_navIconOpen2' : showDropDown_bv.val}" ></div>
            <div :class="{'lc_navIconOpen3' : showDropDown_bv.val}"></div>
        </div>

        <!-- menu dropdown -->
        <div slot="options" class="TQ_bg_white " :style="{'direction' : helper_getDirectionByLangCode_e(p_systemLangCode_e)}">

            <!-- 1. user info-->
            <div class="TQ_padding_8px TQ_border_top" v-if="p_currentUserData_c">
                <tq-avatar :p_ud_avatar_c="p_currentUserData_c.ud_avatar_c"
                           :key="$options.name"
                           v-if="showDropDown_bv.val"
                           class="TQ_inlineGrid TQ_verticalAlignMiddle TQ_width_100p TQ_width_32px TQ_bg_circle TQ_border TQ_box_shadow TQ_borderBox TQ_bg_white "></tq-avatar>

                <div class="userName TQ_inline"> {{p_currentUserData_c.ud_name_s}} </div>
            </div>

            <!-- 2. language -->
            <tq-dropdown class="TQ_dropdown TQ_border_top TQ_fullScreen"
                         :ps_only-mobile-mode_b="true"
                         max-height="420px"
                         :show-caret-down="false">

                <!-- 2.1 current lang -->
                <div slot="select" class="menuOption TQ_grid_col_1frAuto">
                    <div class="label">{{ass_strings.oneWord_language[p_systemLangCode_e]}} </div>
                    <tq-image :pb_src_r="helper_getLangFlagWithLangCode_fr(p_systemLangCode_e)"
                              class="value TQ_width_24px"/>
                </div>

                <!-- 2.2 lang options-->
                <router-link  slot="options"
                              v-for="langCode in enum_langCodes"
                              :key="langCode"
                              class="TQ_noLink_link"
                              :to="m_routeWithLang_s(langCode)">
                    <div class="TQ_border_bottom TQ_center TQ_padding_8px" >
                        <div class="TQ_text_16px"> {{format_langCode_fs(langCode)}} </div>
                        <div class="TQ_inlineGrid TQ_verticalAlignMiddle">
                            <tq-image :pb_src_r="helper_getLangFlagWithLangCode_fr(langCode)" class="TQ_img TQ_width_32px"/>
                        </div>
                    </div>

                </router-link >
            </tq-dropdown>

            <!-- 2. currency -->
            <tq-dropdown class="TQ_dropdown TQ_border_top TQ_fullScreen"
                         v-if="co_playerLocation_b"
                         :ps_only-mobile-mode_b="true"
                         max-height="300px"
                         :show-caret-down="false">

                <!-- 2.1 current currency -->
                <div slot="select" class="menuOption TQ_grid_col_1frAuto">
                    <div class="label">{{ass_strings.oneWord_currency[p_systemLangCode_e]}} </div>
                    <div class="TQ_grid_verticalCenter TQ_padding_4px TQ_text_24px">
                        {{format_costCurrency(p_currentCurrency_e)}}
                    </div>
                </div>

                <!-- 2.2 currency options-->
                <div  slot="options"
                          v-for="currency_e in enum_costCurrency_n"
                          :key="currency_e"
                          class="TQ_noLink_link">
                    <div class="TQ_border_bottom TQ_center TQ_padding_8px "  @click="pe_changeCurrency_f(currency_e)">
                        <div class="TQ_text_24px"> {{format_costCurrency(currency_e)}} </div>
                    </div>
                </div >

            </tq-dropdown>

            <!-- 3. role -->
            <tq-dropdown class="TQ_dropdown TQ_border_top TQ_fullScreen TQ_text_capitalize"
                         v-if="!co_ongoingLocation_b"
                         :ps_only-mobile-mode_b="true"
                         :show-caret-down="false">

                <div slot="select" class="TQ_selected menuOption TQ_grid_col_1frAuto">
                    <div class="label">{{ass_strings.oneWord_role[p_systemLangCode_e]}}</div>
                    <div class="value">{{co_getLocationTitle_s}}</div>
                </div>

                <div slot="options" class="TQ_options TQ_center TQ_text_20px ">
                    <div class="TQ_dropdown_option TQ_padding_12px"
                         @click.stop="m_changeRole_f(enum_moveToLocationOptions.player)">
                        {{ass_strings.oneWord_player[p_systemLangCode_e]}}
                    </div>
                    <div class="TQ_dropdown_option TQ_padding_12px"
                         @click.stop="m_changeRole_f(enum_moveToLocationOptions.creator)">
                        {{ass_strings.oneWord_creator[p_systemLangCode_e]}}
                    </div>
                    <div class="TQ_dropdown_option TQ_padding_12px"
                         v-if="p_currentUserData_c && p_currentUserData_c.ud_accessLevel_n >= enum_accessLevel_byAccessName.route_admin"
                         @click.stop="m_changeRole_f(enum_moveToLocationOptions.admin)">
                        {{ass_strings.oneWord_admin[p_systemLangCode_e]}}
                    </div>
                </div>

            </tq-dropdown>

            <!-- 4. help -->
            <div class="menuOption TQ_grid_col_1frAuto TQ_border_top " v-if="false">
                <div class="label"> {{ass_strings.oneWord_help[p_systemLangCode_e]}} </div>
                <tq-image :pb_src_r="ass_img_help_b" class="value TQ_width_24px"/>
            </div>

            <!-- 5. refresh -->
            <div class="menuOption TQ_grid_col_1frAuto TQ_border_top "
                 @mousedown="m_refreshPage_mousedown_f"
                 @mouseleave="m_refreshPage_mouseleave_f"
                 @mouseup="m_refreshPage_mouseup_f"
                 v-tq-touchstart="m_refreshPage_mousedown_f"
                 v-tq-touchcancel="m_refreshPage_mouseleave_f"
                 v-tq-touchend="m_refreshPage_mouseup_f"
                 @click="m_refreshPage_f">
                <div class="label">{{ass_strings.oneWord_refresh[p_systemLangCode_e]}} <span v-if="holdRefreshTimeSeconds_n < holdRefreshMaxTimeSeconds_n">({{ holdRefreshTimeSeconds_n }}) </span></div>
                <tq-image :pb_src_r="ass_img_refresh_b" class="value TQ_width_24px"/>
            </div>

            <!-- terms of use -->
            <div class="TQ_border_top TQ_padding_12px_8px TQ_text_bold TQ_grid_col_1frAuto">
                <tq-link :p_link_s="enum_moveToOptions.terms_termsOfUse" class="TQ_textColor_black TQ_text_remove_underline">
                    {{ ass_strings.threeWords_termsOfUse[p_systemLangCode_e] }}
                </tq-link>
                <tq-image :pb_src_r="ass_svg_contract_b" class="value TQ_width_24px"/>

            </div>

             <!--6. install pwa-->
            <!--<div class="menuOption TQ_grid_col_1frAuto TQ_border_top"-->
            <!--     v-if="co_displayInstallBtn_f "-->
            <!--     @click.stop="m_installApp_f">-->
            <!--    <div class="label"> {{ass_strings.twoWords_installApp[p_systemLangCode_e]}} </div>-->
            <!--    <img class="value TQ_width_24px" :src="ass_img_install_b"/>-->
            <!--</div>-->


            <!-- 7. dynamic options -->
            <div v-for="menuOption_c in p_navBar_menu_ac" class="menuOption TQ_grid_col_1frAuto TQ_border_top" @click="m_clickDynamicOption_f(menuOption_c.onClickDo_f)">
                <div class="label">{{menuOption_c.text_blc_s[p_systemLangCode_e]}}</div>
                <tq-image :pb_src_r="menuOption_c.img_r" class="value TQ_width_24px"/>
            </div>



        </div>
    </tq-dropdown>
</template>

<script>
    import TqDropdown from "../../components/basic/TqDropdown";
    import TqImage from "../../components/basic/TqImage";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_accessLevel_byAccessName, enum_runIn_es, enum_costCurrency_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {
        route_moveToRoute,
        route_refreshPage,
        route_switchLangCode_es,
        route_addLangToPath_s, route_currentPath_s, route_moveToWindow_f, route_refreshPage_force
    } from "../../router";
    import {store_var, store_getStateValue_vo, store_clean} from "../../store";
    import {format_currentVersion, format_costCurrency} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        helper_getDirectionByLangCode_fe, helper_getLangFlagWithLangCode_fr,
        helper_getScreenSizeCssClass_s,
    } from "../../scripts/S_Helper";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import {
        ass_img_help_b,
        ass_img_info_b,
        ass_img_install_b,
        ass_img_QrCode_b,
        ass_img_menu_b,
        ass_img_user_b,
        ass_img_shareLocation,
        ass_img_locationOff,
        ass_img_refresh_b, ass_img_exit_b, ass_img_document_b, ass_svg_contract_b,
    } from "../../assets/scripts/Ass_Files";
    import TqPopup from "../../components/basic/TqPopup";
    import {format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        enum_langCodes, enum_moveToLocationOptions,
        enum_moveToOptions,
        enum_screenSizesOptions_n
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        date_doEveryClockTick_addCb_f,
        date_doEveryClockTick_removeCb_f,
        date_newDate_fd
    } from "../../scripts/S_Date";
    import {gv_urls} from "../../scripts/S_GlobalVar";
    import TqAvatar from "@/components/complex/TqAvatar";
    import TqLink from "@/components/basic/TqLink";

    export default {
        name: "C_App_MenuDropDown",
        components: {TqLink, TqAvatar, TqPopup, TqBtnApprove, TqDropdown, TqImage},
        props:{
            p_currentUserData_c:{
                type: FB_UserData,
                require: true
            },
            p_systemLangCode_e:{
                type:String,
                require: true
            },
            p_currentVersion_json:{
                type: Object,
                require: true
            },
            p_currentCurrency_e:{
                type: Number,
                require: true,
                validator(val_e) {
                    return validator_enum_fb(enum_costCurrency_n, val_e)
                }
            },
            p_runIn_e: {
                type: String,
                require: true,
                validator(val_e) {
                    return validator_enum_fb(enum_runIn_es, val_e)
                }
            },
            p_navBar_menu_ac : {
                type: Array,
                require: true,
            },

            pe_changeCurrency_f:{
                type: Function,
                require: true,
            }
        },
        data(){
            return {

                showDropDown_bv                 : {val : false},
                holdRefreshTimeSeconds_n        : 6,
                holdRefreshMaxTimeSeconds_n     : 6,

                beforeInstallPrompt             : null,

                enum_langCodes                  : enum_langCodes,
                enum_moveToLocationOptions      : enum_moveToLocationOptions,
                enum_accessLevel_byAccessName   : enum_accessLevel_byAccessName,
                ass_img_menu_b                  : ass_img_menu_b,
                ass_img_info_b                  : ass_img_info_b,
                ass_img_help_b                  : ass_img_help_b,
                ass_img_lockQrCode              : ass_img_QrCode_b,
                ass_img_install_b               : ass_img_install_b,
                ass_img_locationOff             : ass_img_locationOff,
                ass_img_shareLocation           : ass_img_shareLocation,
                ass_img_user_b                  : ass_img_user_b,
                ass_img_exit_b                  : ass_img_exit_b,
                ass_img_refresh_b               : ass_img_refresh_b,
                ass_svg_contract_b              : ass_svg_contract_b,

                windowSizeType_ve               : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // imports
                ass_strings                     : ass_strings,
                enum_costCurrency_n             : enum_costCurrency_n,
                enum_moveToOptions              : enum_moveToOptions,
                enum_windowSizeType             : enum_screenSizesOptions_n,
                format_costCurrency             : format_costCurrency,
                format_langCode_fs              : format_langCode_fs,
                format_currentVersion           : format_currentVersion,

                helper_getDirectionByLangCode_e : helper_getDirectionByLangCode_fe,
                helper_getScreenSizeCssClass_s  : helper_getScreenSizeCssClass_s,
                helper_getLangFlagWithLangCode_fr: helper_getLangFlagWithLangCode_fr,
            }
        },
        computed:{
            co_playerLocation_b(){
                return !this.co_creatorLocation_b && !this.co_ongoingLocation_b && !this.co_adminLocation_b

            },
            co_creatorLocation_b(){
                return route_currentPath_s(this.$route).includes('creator')
            },
            co_ongoingLocation_b(){
                return route_currentPath_s(this.$route).includes('ongoing')
            },
            co_adminLocation_b(){
                return route_currentPath_s(this.$route).includes('admin')
            },
            co_getLocationTitle_s(){
                if(this.co_playerLocation_b){
                    return this.ass_strings.oneWord_player[this.p_systemLangCode_e]
                }else if(this.co_creatorLocation_b){
                    return this.ass_strings.oneWord_creator[this.p_systemLangCode_e]
                }else if(this.co_adminLocation_b){
                    return this.ass_strings.oneWord_admin[this.p_systemLangCode_e]
                }
            },
            co_displayInstallBtn_f(){
                return [enum_runIn_es.android_web_other, enum_runIn_es.android_web_chrome, enum_runIn_es.android_pwa_chrome
                    , enum_runIn_es.ios_web_other, enum_runIn_es.ios_web_safari, enum_runIn_es.ios_web_chrome, enum_runIn_es.ios_pwa_safari
                ].includes(this.p_runIn_e)
            },
        },
        methods:{

            m_routeWithLang_s(langCode_es){
                return route_switchLangCode_es(this.$route, langCode_es)
            },

            m_refreshPage_mousedown_f(){
                console.log('m_refreshPage_mousedown_f')
                date_doEveryClockTick_addCb_f(this.$options.name, () => {
                    this.holdRefreshTimeSeconds_n--
                    if(this.holdRefreshTimeSeconds_n <= 0){
                        date_doEveryClockTick_removeCb_f(this.$options.name)
                        store_clean()
                        route_refreshPage_force()
                    }
                })
            },
            m_refreshPage_mouseleave_f(){
                this.holdRefreshTimeSeconds_n = this.holdRefreshMaxTimeSeconds_n
                date_doEveryClockTick_removeCb_f(this.$options.name)
            },
            m_refreshPage_mouseup_f(){
                this.holdRefreshTimeSeconds_n = this.holdRefreshMaxTimeSeconds_n
                date_doEveryClockTick_removeCb_f(this.$options.name)
            },

            // local methods
            m_refreshPage_f(){
                this.showDropDown_bv.val = false
                route_refreshPage()
            },
            m_changeRole_f(role_e){
                this.showDropDown_bv.val = false

                switch(role_e){
                    case this.enum_moveToLocationOptions.player:
                        if(!this.co_playerLocation_b) {
                            route_moveToRoute(enum_moveToOptions.root)
                        }
                        break;
                    case this.enum_moveToLocationOptions.creator:
                        if(!this.co_creatorLocation_b){
                            route_moveToRoute(enum_moveToOptions.creator)
                        }
                        break;

                    case this.enum_moveToLocationOptions.admin:
                        if(!this.co_adminLocation_b) {
                            route_moveToRoute(enum_moveToOptions.admin)
                        }
                        break;
                }
            },
            m_installApp_f(){


                // this.showDropDown_bv.val = false
                // // hide our user interface that shows our A2HS button
                // // Show the prompt
                // this.beforeInstallPrompt.prompt();
                // // Wait for the user to respond to the prompt
                // this.beforeInstallPrompt.userChoice
                //     .then((choiceResult) => {
                //         if (choiceResult.outcome === 'accepted') {
                //             console.log('User accepted the A2HS prompt');
                //         } else {
                //             console.log('User dismissed the A2HS prompt');
                //         }
                //         this.beforeInstallPrompt = null;
                //     });


                switch(this.p_runIn_e){
                    case enum_runIn_es.android_web_other:
                    case enum_runIn_es.android_web_chrome:
                    case enum_runIn_es.android_pwa_chrome:
                        route_moveToWindow_f(gv_urls.googleStore)
                        break;

                    case enum_runIn_es.ios_web_other:
                    case enum_runIn_es.ios_web_safari:
                    case enum_runIn_es.ios_web_chrome:
                    case enum_runIn_es.ios_pwa_safari:
                        route_moveToWindow_f(gv_urls.appStore)
                        break;
                }

            },
            m_clickDynamicOption_f(onClickDo_f){

                onClickDo_f()
            }


        },

        mounted(){

            // eventListener_addEventListenerToObj(window, enum_eventsListenersNames.beforeinstallprompt, false, this.$options.name , (e) =>{
            //
            //     console.log(e)
            //
            //     // Prevent Chrome 67 and earlier from automatically showing the prompt
            //     e.preventDefault();
            //     // Stash the event so it can be triggered later.
            //     this.beforeInstallPrompt = e
            // })
        },
        destroyed() {
            // eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.beforeinstallprompt, this.$options.name)
        }

    }
</script>

<style scoped lang="scss">


    .lc_navIcon {

        div {
            background-color: #501078;
            background-color: var(--color-purple);
            /*border-radius: 3px;*/
            content: '';
            display: block;
            /*height: 4px;*/
            /*margin: 6px 0;*/
            transition: all .2s ease-in-out;
            border-radius: 4px;


        }

        &.lc_laptop{
            width: 42px;
            margin: 14px 8px;

            div{

                height: 5px;
                margin: 8px 0 0 0;
                border-radius: 32px;

                &.lc_navIconOpen1 {
                    transform: translateY(13px) rotate(135deg);
                }
                &.lc_navIconOpen2 {
                    transform: scale(0);
                }
                &.lc_navIconOpen3 {
                    transform: translateY(-13px) rotate(-135deg);
                }
            }
        }
        &.lc_tablet_big,
        &.lc_tablet_small{

            width: 36px;
            margin: 12px 6px;
            border-radius: 32px;


            div{

                height: 4px;
                margin: 7px 0 0 0;

                &.lc_navIconOpen1 {
                    transform: translateY(11px) rotate(135deg);
                }
                &.lc_navIconOpen2 {
                    transform: scale(0);
                }
                &.lc_navIconOpen3 {
                    transform: translateY(-11px) rotate(-135deg);
                }
            }
        }
        &.lc_mobile{

            width: 32px;
            margin: 8px 4px;

            div{

                height: 4px;
                margin: 6px 0 0 0;

                &.lc_navIconOpen1 {
                    transform: translateY(10px) rotate(135deg);
                }
                &.lc_navIconOpen2 {
                    transform: scale(0);
                }
                &.lc_navIconOpen3 {
                    transform: translateY(-10px) rotate(-135deg);
                }
            }
        }

    }

    .lc_options {
        transition: all 10s ease-in-out;
        background: green;
    }


    .menuOption{
        min-height: 40px;
        padding: 4px 8px;

        .label{
            align-self: center;
            text-transform: capitalize;
            font-weight: bold;
        }
        .value{
            align-self: center;
        }
    }

    img.user {
        border: 1px #2E294E solid;
        border: 1px var(--color-purple-dark) solid;
        border-radius: 50%;
        padding: 1px;
        /*margin-top: 1px;*/
    }

    .userName{
        margin: 0 8px
    }



</style>